module.exports = __webpack_public_path__ + "img/49.3.TP.f355c49e.png";